import React from "react";

export interface PageContentContextValues {
  isFullHeight: boolean | undefined;
}

const PageContentContext = React.createContext<PageContentContextValues>({
  isFullHeight: undefined,
});

export const usePageContentContext = () => React.useContext(PageContentContext);

export const PageContentContextProvider: React.FC<
  React.PropsWithChildren<PageContentContextValues>
> = ({ isFullHeight, children }) => (
  <PageContentContext.Provider value={{ isFullHeight }}>
    {children}
  </PageContentContext.Provider>
);
